import moment from 'moment'
import { DateTimeFormatSimple, DateTimeFormatSimpleOnly, DateTimeFormatSimpleOnlyOne } from './datetime'

export function ISRegionTotalPrintBody(data: any) {
  const tenantName = data?.tenantName
  const timeHead = data?.timeHead ? moment(data?.timeHead).format(DateTimeFormatSimpleOnly) : ''
  const timeTail = data?.timeTail ? moment(data?.timeTail).format(DateTimeFormatSimpleOnly) : ''
  const dataList = data?.data
  let dataStr = ''
  let totalPriceAll = 0.0
  let cashAmountAll = 0.0
  let insurancePayAmountAll = 0.0
  let jibenylbxtcjjzcAll = 0.0
  let gerenzhzcAll = 0.0
  let discountAmountAll = 0.0

  const hideList: any = localStorage.getItem(
    'jycxReload_table_column_filter'
  )
  const hideColumnList = JSON.parse(hideList)

  for (let j = 0; j < dataList.length; j++) {
    dataStr +=
      '<div style="display: table;width: 100%;justify-content: center;align-items: center;box-sizing: border-box;border-right: 1px solid #000000;border-left: 1px solid #000000;border-bottom: 1px solid #000000;text-align: center;">' +
      '<div style="width:8%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">' +
      dataList[j].areaName +
      '</div>'+
      '<div style="width: 7%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">' +
      dataList[j].renyuanlx +
      '</div>'+
      '<div style="width:9%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">' +
      dataList[j].totalPayAmount +
      '</div>'+
      '<div style="width:9%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">' +
      dataList[j].reimbursementAmount +
      '</div>'+
      '<div style="width:9%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">' +
      dataList[j].jibenylbxtcjjzc +
      '</div>'+
      '<div style="width:8%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">' +
      dataList[j].gerenzhzc +
      '</div>' +
      '<div style="width:8%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">' +
      dataList[j].gerenxjzc +
      '</div>' +
      '<div style="width:8%;display: table-cell;box-sizing: border-box;font-size: 8px;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">' +
      dataList[j].jijinzfze +
      '</div>' +
      '</div>'
    totalPriceAll += parseFloat(dataList[j].totalPayAmount)
    cashAmountAll += parseFloat(dataList[j].reimbursementAmount)
    insurancePayAmountAll += parseFloat(dataList[j].jibenylbxtcjjzc)
    jibenylbxtcjjzcAll += parseFloat(dataList[j].gerenzhzc)
    gerenzhzcAll += parseFloat(dataList[j].gerenxjzc)
    discountAmountAll += parseFloat(dataList[j].jijinzfze)
  }

  
  const contents =
    '<div style="page-break-after:always;page-break-inside:always;page-break-before:always;">' +
    '<h3 style="text-align: center;margin-bottom: 5px;" >医保结算地区汇总数据</h3>' +
    '<div style="text-align: left;padding-bottom: 8px;font-weight: 600;font-size:13px">' +
    '<div style="display: inline-block;width: 100%;text-align: center;">' +
    '<font style="font-weight: 300;">' +
    timeHead +
    '</font>' +
    ' <font style="font-weight: 300;">至</font>' +
    '<font style="font-weight: 300;">' +
    timeTail +
    '</font>' +
    '</div>' +
    '<div style="display: flex;width: 100%;text-align: center;"aign-items: center;jcustify-content: space-between;">' +
    ' <div style="display: inline-block;width: 50%;text-align: left;">' +
    '<font style="font-weight: 300;">' +
    tenantName +
    '</font>' +
    '</div>' +
    ' <div style="display: inline-block;width: 50%;text-align: right;">' +
    '<font style="font-weight: 300;">单位：元（下至角分）' +
    '</font>' +
    '</div>' +
    '</div>' +
    '</div>' +
    '<div style="display: table;width: 100%;justify-content: center;align-items: center;box-sizing: border-box;border-right: 1px solid #000000;border-left: 1px solid #000000;border-top: 1px solid #000000;border-bottom: 1px solid #000000;text-align: center;">' +
    '<div style="width:8%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">地区' +
    '</div>' +
    '<div style="width:7%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">人员类型' +
    '</div>'+
    '<div style="width:9%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">费用总额' +
    '</div>'+
    '<div style="width:9%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">报销金额' +
    '</div>'+
    '<div style="width:9%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">统筹基金支付' +
    '</div>' +
    '<div style="width:8%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">个人账户支付' +
    '</div>' +
    '<div style="width:8%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">个人现金支付' +
    '</div>' +
    '<div style="width:8%;display: table-cell;box-sizing: border-box;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">基本支付金额' +
    '</div>' +
    '</div>' +
    dataStr +
    '<div style="display: table;width: 100%;justify-content: center;align-items: center;box-sizing: border-box;border-right: 1px solid #000000;border-left: 1px solid #000000;border-bottom: 1px solid #000000;text-align: center;">' +
    '<div style="width: 15%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">合计' +
    '</div>' +
    '<div style="width:9%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">' +
    totalPriceAll?.toFixed(2) +
    '</div>'+
    '<div style="width:9%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">' +
    cashAmountAll?.toFixed(2) +
    '</div>' +
    '<div style="width:9%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">' +
    insurancePayAmountAll?.toFixed(2) +
    '</div>' +
    '<div style="width:8%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">' +
    jibenylbxtcjjzcAll?.toFixed(2) +
    '</div>' +
    '<div style="width:8%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">' +
    gerenzhzcAll?.toFixed(2) +
    '</div>' +
    '<div style="width:8%;display: table-cell;box-sizing: border-box;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">' +
    discountAmountAll?.toFixed(2) +
    '</div>' +
    ' </div>' +
    '</div>'
  return contents
}
